import { render } from "./Ofertagrid.vue?vue&type=template&id=1d487eeb&scoped=true"
import script from "./Ofertagrid.vue?vue&type=script&lang=js"
export * from "./Ofertagrid.vue?vue&type=script&lang=js"

import "./Ofertagrid.vue?vue&type=style&index=0&id=1d487eeb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d487eeb"

export default script